import { Tabs, TabsProps } from '@amzn/awsui-components-core';
import React, { useEffect, useState } from 'react';
import { TechDomain, TechDomainDisplayNames } from '@amzn/awscat-pattern-library-service-model';
import kebabCase from 'kebab-case';
import { DraftBarRaiserDashboard } from '../../bar-raiser/DraftBarRaiserDashboard';
import { PublishedBarRaiserDashboard } from '../../bar-raiser/PublishedBarRaiserDashboard';
import {
  defaultQueryGroupsOperation,
  draftContentSelectorOptions,
  draftDashboardQueryGroups,
  draftTableColumns,
  publishedContentSelectorOptions,
  publishedDashboardQueryGroups,
  publishedTableColumns,
} from '../../utils/BarRaiser';

// @ts-expect-error TS7006 - strict migration
export function GeneralBarRaiserDashboard(props) {
  const { techDomain: techDomainShortName } = props.match.params;
  // @ts-expect-error TS7053 - strict migration
  const techDomain = TechDomain[kebabCase.reverse('-' + techDomainShortName)];
  const techDomainDisplay = TechDomainDisplayNames.get(techDomain) ?? 'Databases';

  const [activeTabId, setActiveTabId] = useState<string>('br-draft-contents');

  useEffect(() => {
    if (props.location.state?.activeTabId) {
      setActiveTabId(props.location.state?.activeTabId);
    }
  }, [props.location.state]);

  const handleTabChange = (event: CustomEvent<TabsProps.ChangeDetail>) => {
    setActiveTabId(event.detail.activeTabId);
  };

  return (
    <Tabs
      // @ts-expect-error TS2322 - strict migration
      onChange={handleTabChange}
      activeTabId={activeTabId}
      ariaLabel="Bar raiser dashboard navigation"
      tabs={[
        {
          label: 'New or updated content',
          id: 'br-draft-contents',
          content: (
            <DraftBarRaiserDashboard
              headerSuffix={techDomainDisplay}
              queryGroups={draftDashboardQueryGroups(techDomain)}
              queryGroupsOperation={defaultQueryGroupsOperation}
              techDomain={techDomain}
              allContentTableColumns={draftTableColumns}
              contentSelectorOptions={draftContentSelectorOptions}
            />
          ),
        },
        {
          label: 'Published - needs review',
          id: 'br-published-contents',
          content: (
            <PublishedBarRaiserDashboard
              headerSuffix={techDomainDisplay}
              queryGroups={publishedDashboardQueryGroups(techDomain)}
              queryGroupsOperation={defaultQueryGroupsOperation}
              techDomain={techDomain}
              allContentTableColumns={publishedTableColumns}
              contentSelectorOptions={publishedContentSelectorOptions}
            />
          ),
        },
      ]}
    />
  );
}
